import { ArrowLeft } from "lucide-react";
import { Link } from "react-router";
import { Brand } from "../components/Brand";
import { ui } from "../lib/ui";

export function NotFoundPage() {
  return <main id="main-content" className="room-gate" tabIndex={-1}><Brand /><div><h1>{ui("This route left the room.", "Такой страницы нет.")}</h1><p>{ui("The page may have moved, or the invitation link is incomplete.", "Страница могла переехать, или ссылка на комнату неполная.")}</p><Link className="button button--primary" to="/"><ArrowLeft aria-hidden="true" size={17} />{ui("Back home", "На главную")}</Link></div></main>;
}
